import React, { useEffect, useRef } from 'react'
import clsx from 'clsx'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { checkIsActive, KTSVG } from '../../../helpers'
import { useLayout } from '../../core'
import { solicitarDemonstracaoSeBloqueado } from '../../../../app/utils/agendarDemonstracao'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean,
  external?: boolean,
  show?: boolean
  badge?: string
  bloqueado?: boolean
}

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  external = false,
  show = true,
  badge,
  bloqueado = false
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { aside } = config
  const linkRef = useRef<HTMLAnchorElement>(null)
  const history = useHistory()

  // O tema Metronic (MenuComponent.ts) registra um listener nativo em
  // document.body para ".menu-item > .menu-link" que chama e.stopPropagation()
  // no clique. Como o projeto usa React 16 (delega os eventos sintéticos no
  // document, não na raiz do app), esse listener do body é atingido ANTES do
  // React conseguir ver o clique — o stopPropagation() barra o evento antes
  // dele chegar no document, e o onClick do React nunca dispara. Por isso o
  // bloqueio precisa de um listener nativo na fase de CAPTURA, direto no <a>,
  // que roda antes de qualquer handler de bubble (inclusive o do Metronic).
  useEffect(() => {
    const node = linkRef.current
    if (!node) return

    const nativeClickHandler = (e: MouseEvent) => {
      if (bloqueado) {
        e.preventDefault()
        e.stopPropagation()
        solicitarDemonstracaoSeBloqueado(title, () => history.push('/andamento-contas'))
      }
    }

    node.addEventListener('click', nativeClickHandler, true)
    return () => node.removeEventListener('click', nativeClickHandler, true)
  }, [bloqueado, title, history])

  return (
    <div className='menu-item' style={{
      //marginLeft: '10%'
      display: !show ? 'none' : 'unset'
    }}>
      <Link ref={linkRef} className={clsx('menu-link without-sub', { active: isActive })} to={external ? { pathname: to } : to} target={external ? '_blank' : '_self'}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}

        {fontIcon && aside.menuIcon === 'font' &&
          <i className={clsx('icon-lg text-white fs-1', fontIcon)}></i>
        }
        <span className='menu-title text-white'
          style={{
            marginLeft: '8%',
            fontSize: '20px',
            position: 'relative',
            display: 'inline-block'
          }}>
          {title}
          {badge && (
            <span
              title={badge}
              style={{
                position: 'absolute',
                top: '50%',
                right: '0',
                transform: 'translateY(-50%) rotate(27deg)',
                background: '#fff',
                color: '#009ef7',
                fontWeight: 700,
                fontSize: '11px',
                lineHeight: 1,
                padding: '2px 10px',
                borderRadius: '2px',
                whiteSpace: 'nowrap',
                pointerEvents: 'none',
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.35)'
              }}
            >
              {badge}
            </span>
          )}
        </span>
      </Link>
      {children}
    </div >
  )
}

export { AsideMenuItem }
